import React from 'react';
import SmallCard from "../../../components/common/SmallCard/SmallCard"

const TrustedByBrands = () => {
    return (
        <><SmallCard /></>
    )
}

export default TrustedByBrands